import { BookendType, REACT_COMP_VERSION } from "constants"
import { logger } from '../logger';

export const addScriptsToDocument = (scripts: {src: string, innerHTML: string}[]) => {
  scripts.forEach(scriptObj => {
    const scriptElement = document.createElement("script")
    if (scriptObj.src) scriptElement.src = scriptObj.src
    if (scriptObj.innerHTML) scriptElement.innerHTML = scriptObj.innerHTML
    document.body.appendChild(scriptElement)
  })
}

export const getHeaderKey = (
  tenant: string, 
  locale: string, 
  headerType: BookendType, 
  hideSearch?: boolean, 
  hideVat?: boolean,
  showStickyHeader?: boolean
) => {
  return `${REACT_COMP_VERSION}_${tenant}_${locale}_header_${headerType}_hidesearch-${hideSearch || false}_hideVat-${hideVat || false}${showStickyHeader ? "_showStickyHeader-true" : ""}`.toLowerCase()
}

export const getFooterKey = (tenant: string, locale: string, footerType: BookendType) => {
  return `${REACT_COMP_VERSION}_${tenant}_${locale}_footer_${footerType}`.toLowerCase()
}

export const makeFileRequest = (stagingContent: boolean | undefined, filePath: string) => {
  const url = stagingContent ?
  `https://bookends-html-dev.s3.eu-west-1.amazonaws.com${filePath.replace(/^((\/esi)|(\/html))/, "")}` :
  `https://bookends.cdn.vpsvc.com${filePath}`
  return fetch(url)
  .then((response: any) => {
    if(!response.ok) {
      throw new Error(`Request failed with response code ${response.status}`)
    }
    return response.text()
  })
  .catch(ex => {
    logger.error(
      "Failed to add header bundle on client", 
      {
        contextData: {
          message: ex.message,
          error: ex,
          url
        }
      }
    )
    return ""
  })
}